<template>
  <div 
    v-if="numberOfImages"
    ref="container"
    :class="[
      containerClass,
      { 'dots-container--transparent': transparentBackground }
    ]">
    <div
      ref="curtain"
      class="dots-container__curtain">
      <div
        v-for="(_, index) in numberOfImages"
        :id="`roomie-navigation-dots-${index}`"
        :key="index"
        :ref="`dots-${index}`"
        class="dots-container__dot_holder">
        <span
          :class="dotClasses[index]" />
      </div>
    </div>
  </div>
</template>

<script>
import { DOT_CLASSES, DOT_CONTAINER_CLASSES} from './utils'

export default {
  name: 'RoomieNavigationDots',
  props: {
    numberOfImages: {
      type: Number,
      default: 0,
      required: true
    },
    currentPosition: {
      type: Number,
      default: 0,
      required: true
    },
    transparentBackground: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pointer: 0,
      dotClasses: {},
      numberOfSwipes: 0,
    }
  },
  computed:{
    containerClass() {
      return this.numberOfImages <= 3 ? DOT_CONTAINER_CLASSES.dotsContainerCenteredContent : DOT_CONTAINER_CLASSES.dotsContainer
    }
  },
  watch: {
    currentPosition: function(newPosition, oldPosition) {
      oldPosition = this.normalizePosition(oldPosition)
      newPosition = this.normalizePosition(newPosition)
      
      if (newPosition > oldPosition) {
        let numberOfSwipes = newPosition - oldPosition
        this.swipeRight(numberOfSwipes)
      }

      if ( newPosition < oldPosition) {
        let numberOfSwipes =  oldPosition - newPosition 
        this.swipeLeft(numberOfSwipes)
      }

      this.translateCurtain(newPosition, oldPosition)
    },
    numberOfImages: function() {
      this.initializePointer()
    }
  },
  mounted() {
    this.initializePointer()
  },
  methods: {
    normalizePosition (position) {
      position = Math.max(0, position)
      position = Math.min(this.numberOfImages - 1, position)
      return position
    },
    initializeDotClasses () {
      const dotClasses = {}
      for(let i = 0; i < this.numberOfImages; i++) {
        if (i == 0) dotClasses[i] = DOT_CLASSES.bigDotActive
        else if (i >= 3) dotClasses[i] = DOT_CLASSES.smallDot
        else dotClasses[i] =  DOT_CLASSES.bigDotInactive
      }
      this.dotClasses = dotClasses
    },
    initializePointer () {
      this.initializeDotClasses()
      this.swipeRight(this.currentPosition)
    },
    swipeRight (numberOfSwipes) {
      for(let i = 1 ; i <= numberOfSwipes ; i ++ ) {
        if (this.pointer < this.numberOfImages - 1) {
          this.pointer = this.pointer + 1
          this.actualizeDotClassesRight()
        }
      }
    },
    swipeLeft (numberOfSwipes) {
      for (let i = 1; i <= numberOfSwipes; i++) {
        if (this.pointer > 0) {
          this.pointer = this.pointer - 1
          this.actualizeDotClassesLeft()  
        }
      }
    },
    actualizeDotClassesRight () {
      const smallDotLeft = this.$refs[`dots-${this.pointer - 2}`]?.[0]
      if (smallDotLeft) smallDotLeft.style.justifyContent = 'end'

      const newDotClasses = { [this.pointer]: DOT_CLASSES.bigDotActive, [this.pointer - 1]: DOT_CLASSES.bigDotInactive }

      if (this.dotClasses[this.pointer] == 'dots-container__dot dots-container__dot--small') {
        this.dotClasses = { ...this.dotClasses, ...newDotClasses, [this.pointer - 3]: DOT_CLASSES.smallDot, [this.pointer - 2]: DOT_CLASSES.smallDot }
        
        // last dot
        if (this.pointer == this.numberOfImages - 1) {
          this.dotClasses = { ...this.dotClasses, [this.pointer - 2]: DOT_CLASSES.bigDotInactive }
        } else if (this.pointer == this.numberOfImages - 2 ) { //one before last dot
          this.dotClasses = { ...this.dotClasses, [this.pointer + 1]: DOT_CLASSES.bigDotInactive}
        }
      } else {
        this.dotClasses = { ...this.dotClasses, ...newDotClasses }
      }
    
    },
    actualizeDotClassesLeft () {
      const smallDotRight = this.$refs[`dots-${this.pointer + 2}`]?.[0]
      if (smallDotRight) smallDotRight.style.justifyContent = 'start'

      const newDotClasses = { [this.pointer]: DOT_CLASSES.bigDotActive, [this.pointer + 1]: DOT_CLASSES.bigDotInactive }
  
      if (this.dotClasses[this.pointer] == 'dots-container__dot dots-container__dot--small') {
        this.dotClasses = { ...this.dotClasses, ...newDotClasses, [this.pointer + 2]: DOT_CLASSES.smallDot, [this.pointer + 3]: DOT_CLASSES.smallDot}
        
        // second dot
        if (this.pointer == 1) {
          this.dotClasses = { ...this.dotClasses, [this.pointer - 1]: DOT_CLASSES.bigDotInactive}
        }
        
      } else {
        if (this.pointer == 1) {
          this.dotClasses = { ...this.dotClasses, ...newDotClasses, [this.pointer - 1]: DOT_CLASSES.bigDotInactive, [this.pointer + 2]:DOT_CLASSES.smallDot }
        }
        this.dotClasses = { ...this.dotClasses, ...newDotClasses } 
      }
    },
    translateCurtain(position, oldPosition) {

      const container = this.$refs.container
      const pointer = this.$refs[`dots-${position}`][0]
      const pointerWidth = this.$refs[`dots-${position}`][0].offsetWidth
      let translateSize = pointerWidth * 3
      
      if (position < oldPosition) {
        const selectedPointer = this.$refs[`dots-${oldPosition}`][0]
        translateSize = translateSize + selectedPointer.offsetWidth
      }
      
      const offsetPosition = container.offsetWidth - pointer.offsetLeft - translateSize
      let amount = Math.min(0, offsetPosition)
      amount = Math.max(amount, container.offsetWidth- container.scrollWidth)

      const curtain = this.$refs['curtain']
      curtain.style.transform = `translateX(${amount}px)`
      curtain.classList.add('translation')
    }
  },
}
</script>

<style src='./_index.scss' lang='scss'/>
